import React from 'react';
import Popup from 'react-popup';
import './UserInstructions.component.css';

import CountdownTimer from './countdown-timer/CountdownTimer.component';

export default class UserInstructions extends React.Component {

    constructor(props) {
        super(props);

        this.onCountdownExpired = this.onCountdownExpired.bind(this);
    }

    onCountdownExpired() {
        Popup.alert('The page data has expired and the page must refresh','Page Expired');

        this.props.onTimeExpires();
    }

    render() {
        return (
            <div>
                <div className="user-instruction-container">
                    Please select the appointment(s) you wish to confirm below. <br />
                    If required, please add Appointment Reference Numbers where indicated. <br />
                    If available, please add Preloaded Equipment Decal IDs where indicated. <br />
                    Click Submit at the bottom of the page to finish confirming all appointments selected. <br />
                    <b>NOTE: appointments will not be confirmed until you click Submit.</b>
                </div>
                <div className="countdown-timer-container">
                    <span className="expires-message">
                        Page Expires in: <CountdownTimer onCountdownExpired={this.onCountdownExpired}></CountdownTimer>
                    </span>
                </div>
            </div>
        );
    }
}
